import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function SubscriptionSuccess() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/billing/status/${sid}`);
        if (data.payment_status === "paid") { setState("ok"); refresh?.(); return; }
        if (data.status === "expired" || tries > 12) { setState("error"); return; }
      } catch { if (tries > 12) { setState("error"); return; } }
      setTimeout(poll, 2000);
    };
    poll();
  }, [refresh]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl p-8 text-center space-y-4" data-testid="subscription-success-page">
        {state === "checking" && <><Loader2 className="w-10 h-10 animate-spin text-emerald-600 mx-auto" /><p className="text-sm text-slate-500">Confirmation du paiement…</p></>}
        {state === "ok" && <>
          <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto" data-testid="sub-success" />
          <h2 className="font-heading text-xl font-bold text-slate-900">Abonnement activé</h2>
          <p className="text-sm text-slate-500">Merci ! Votre abonnement Auto Detail Manager est actif.</p>
          <Button onClick={async () => { await refresh?.(); navigate("/dashboard"); }} data-testid="btn-go-dashboard" className="w-full bg-emerald-500 hover:bg-emerald-600 text-black font-semibold">Aller au tableau de bord</Button>
        </>}
        {state === "error" && <>
          <XCircle className="w-12 h-12 text-red-500 mx-auto" />
          <h2 className="font-heading text-xl font-bold text-slate-900">Paiement non confirmé</h2>
          <p className="text-sm text-slate-500">Si vous avez été débité, le statut se mettra à jour sous peu.</p>
          <Button onClick={() => navigate("/abonnement")} className="w-full bg-slate-900 text-white">Retour à l'abonnement</Button>
        </>}
      </div>
    </div>
  );
}
